export default "__VITE_ASSET__DfAhzzlA__"